export const environmentDefaults = {
  // Pioneer Server Endpoints
  baseUrl: 'http://localhost:8080',
  hostname: 'localhost',

  // angular-cli compile mode
  production: true,

  // AWS Configuration
  region: 'us-east-1',
  awsUri: 'amazonaws.com',

  // Log handlers and log levels
  logServices: {
    consoleLogSubscriber: {
      logLevel: 3
    },
    httpLogSubscriber: {
      logLevel: 0
    }
  },

  // Close messages at 3.5 seconds
  alertMessageTimer: 3500,

  emailValidation: false,

  events: {
    maxEvents: 100,
    acceptedFileExtensions: '.jpg, .jpeg, .pdf',
    acceptedFileTypes: [ 'application/pdf', 'image/jpeg' ],
    maxFileSize: 100
  },

  bulkEvents: {
    acceptedFileExtensions: '.csv',
    acceptedFileTypes: [ 'text/csv', 'text/x-csv', 'text/plain', 'application/vnd.ms-excel' ]
  },

  rsvps: {
    acceptedFileExtensions: '.xlsx',
    acceptedFileTypes: [ 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ]
  },

  reservations: {
    acceptedFileExtensions: [ '.xlsx' ],
    acceptedFileTypes: [ 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ]
  },

  payments: {
    paymentDelayDaysAfterEventEnd: 3
  },

  googleAnalytics: {
    id: 'UA-92766055-1',
    loadType: 'auto'
  },

  policyUrl: 'https://onyxcentersource.com/privacy-policy/',
  portalUrl: 'https://portal.uat.onyxcentersource.com',
  onyxCommonDataUrl: 'https://ocd-service.uat.onyxcentersource.com/api',
  // redirect to portal after 3 seconds
  portalRedirectTimer: 3000,
  portalLogout: '/j_spring_security_logout',
  allowApiDocs: false
};



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/environments/environment-defaults.ts